import { betTypesRtpFormulas } from '../enums/betTypesRtpFormulas';

export const rtpFormulaCalculator = (odd, name) => {
  return odd * betTypesRtpFormulas[name] * 100;
};
